<template>
    <div style="padding-top:1px;" class="index_page">
        <!-- <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel> -->
        <!-- <div v-if="!showVideo" class="logoWrap" id="logoBox">
            <div class="imgBox" id="imgBox">
				<img src="../assets/biaoti.png"/>
			</div>
        </div>
        <div v-if="showVideo" style="width:80%;margin:0 auto;">
            <video-player style="width:100%;margin:0 auto;box-shadow:5px 5px 8px #888888"  class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    @ended="onPlayerEnd($event)"
                    :options="playerOptions0"
            ></video-player>
        </div> -->
        <div style="z-index:100;position: relative;">
            <div class="solve head-label just_center" style="margin-top:110px;"
                :style="{ paddingTop: (!showVideo ? '600px' : '0px') }">
                <img style="width:34px;" src="../assets/sangang1.png">
                <div style="text-align: center;margin-left:20px;margin-right:20px;font-weight:700;font-family:Microsoft YaHei;"
                    class="font_size_24">
                    走进汇升
                </div>
                <img style="width:34px;" src="../assets/sangang2.png">
            </div>
            <div style="position:relative;margin-top:35px;">
                <img style="width:100%;" src="../assets/juanmahua.png">
                <div
                    style="position:absolute;top:-5px;left:50%;transform: translateX(-50%);font-size: 32px;text-align:center;">
                    苏豪汇升 —— 您的全天候资产配置专家
                </div>
                <div
                    style="position:absolute;top:80px;left:50%;transform: translateX(-50%);margin: 0 auto;width: 160px;height:46px;border-radius:23px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div @click="enterHs()"
                        style="font-size:16px;font-weight:600;text-align:center;border-radius:20px;background:#3fa8c7;color:#ffffff;width:150px;height:40px;line-height:40px;cursor:pointer;">
                        了解更多
                        <img style="vertical-align: middle;" src="../assets/jiantou.png" />
                    </div>
                </div>
                <!-- <div style="margin: 0 auto;margin-top:20px;width: 132px;height:36px;border-radius:18px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div style="font-size:12px;font-weight:600;text-align:center;border-radius:15px;background:#3fa8c7;color:#ffffff;width:120px;height:30px;line-height:30px;">社会招聘
                    </div>
                </div> -->

                <div style="position:absolute;top:300px;width:70%;margin-left: 50%;transform: translateX(-50%);">
                    <div style="display: flex;">
                        <div style="width:40%">
                            <div style="display:flex;">
                                <img style="width:32px;" src="../assets/juxing1.png" />
                                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png" />
                                <img style="width:32px;" src="../assets/juxing3.png" />
                            </div>
                            <div style="font-size:48px;font-weight:700;margin-top:15px;">2006年</div>
                            <div style="font-size:20px;">国有上市公司旗下私募基金</div>
                        </div>
                        <div style="width:35%;">
                            <div style="display:flex;">
                                <img style="width:32px;" src="../assets/juxing1.png" />
                                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png" />
                                <img style="width:32px;" src="../assets/juxing3.png" />
                            </div>
                            <div style="font-size:48px;font-weight:700;margin-top:15px;">50亿+</div>
                            <div style="font-size:20px;">管理规模</div>
                        </div>
                        <div style="width:25%">
                            <div style="display:flex;">
                                <img style="width:32px;" src="../assets/juxing1.png" />
                                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png" />
                                <img style="width:32px;" src="../assets/juxing3.png" />
                            </div>
                            <div style="font-size:48px;font-weight:700;margin-top:15px;">50+</div>
                            <div style="font-size:20px;">核心团队成员毕业于清华、交大等</div>
                            <div style="font-size:20px;">国内外一流院校</div>
                        </div>
                    </div>
                    <div style="display: flex;margin-top:20px;">
                        <div style="width:40%">
                            <div style="display:flex;">
                                <img style="width:32px;" src="../assets/juxing1.png" />
                                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png" />
                                <img style="width:32px;" src="../assets/juxing3.png" />
                            </div>
                            <div style="font-size:46px;font-weight:600;margin-top:15px;">40+</div>
                            <div style="font-size:20px;">中国基金报英华奖、证券时报金长江奖等</div>
                            <div style="font-size:20px;">
                                行业顶尖荣誉
                            </div>
                        </div>
                        <div style="width:35%">
                            <div style="display:flex;">
                                <img style="width:32px;" src="../assets/juxing1.png" />
                                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png" />
                                <img style="width:32px;" src="../assets/juxing3.png" />
                            </div>
                            <div style="font-size:46px;font-weight:600;margin-top:15px;">60+</div>
                            <div style="font-size:20px;">专业合作机构</div>
                        </div>
                        <div style="width:25%">
                            <div style="display:flex;">
                                <img style="width:32px;" src="../assets/juxing1.png" />
                                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png" />
                                <img style="width:32px;" src="../assets/juxing3.png" />
                            </div>
                            <div style="font-size:46px;font-weight:600;margin-top:15px;">5亿</div>
                            <div style="font-size:20px;">注册资本</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div :style="{backgroundImage: 'url('+bgImage+')'}" style="width: 100%;background-position: center top;background-repeat: no-repeat;background-size: cover;">

            </div> -->
            <div :style="{ backgroundImage: 'url(' + peizhi + ')' }"
                style="position:relative;margin-top:160px;width:100%;background-position: center center;background-repeat: no-repeat;background-size: cover;">
                <div
                    style="position:absolute;top:-3px;left:50%;margin-left:-66px;width:133px;height:7px;background:#3fa8c7;border-radius:4px;">
                </div>
                <div class="solve head-label just_center"
                    style="padding-top: 100px;border-top:1px solid rgba(112, 112, 112, 0.2);">
                    <img style="width:34px;" src="../assets/sangang1.png">
                    <div style="text-align: center;margin-left:20px;margin-right:20px;font-weight:700;font-family:Microsoft YaHei;"
                        class="font_size_24">
                        汇升资产配置体系
                    </div>
                    <img style="width:34px;" src="../assets/sangang2.png">
                </div>
                <div class="solve head-label" style="margin-top:50px;margin-bottom:0px;padding-bottom:120px;">
                    <div style="width:82%;margin:0 auto;margin-top:80px;display: flex;">
                        <div style="width:50%;">
                            <img style="width:86%;" src="../assets/shengtaixitong.png">
                        </div>
                        <div style="width:48%;position:relative;font-size:20px;padding-top:3px;">
                            <div style="color:#3fa8c7;font-size:36px;">汇升资产配置体系</div>
                            <div style="font-weight:600;margin-top:40px;line-height: 36px;">多资产、多元策略、多子管理人的资产配置体系</div>
                            <div style="font-weight:600;margin-top:3px;line-height: 36px;">力争将“投资收益”真正转化为“投资者收益”</div>
                            <div style="margin-top:10px;text-align:justify;line-height: 36px;">
                                汇升秉承自上而下的配置理念，从宏观分析到大类资产配置，围绕股票多头、市场中性、固定收益、期货、套利和可转债六大类资产，覆盖低、中、高频等交易特征和差异化的趋势、套利、波动等策略体系，精准描绘投顾的画像，并利用科学的组合构建、管理及风控，形成从投前、投中到投后完整的配置决策流程，以期获得稳定的投资回报。
                            </div>
                            <div style="margin-top:46px;font-weight:600;line-height: 33px;">
                                · 自上而下主动管理
                            </div>
                            <div style="margin-top:3px;font-weight:600;line-height: 33px;">
                                · 灵活母基金调仓
                            </div>
                            <div style="margin-top:3px;font-weight:600;line-height: 33px;">
                                · 自建核心策略团队
                            </div>
                            <div style="margin-top:3px;font-weight:600;line-height: 33px;">
                                · 专业尾部风险管理
                            </div>
                            <div style="margin-top:3px;font-weight:600;line-height: 33px;">
                                · 优秀子管理人下沉
                            </div>
                            <div style="margin-top:3px;font-weight:600;line-height: 33px;">
                                · 底层子基金费率优惠
                            </div>

                            <div style="position:absolute;right:50px;bottom:2%;">
                                <img style="width:32px;" src="../assets/juxing3.png" />
                                <img style="width:32px;" src="../assets/juxing1.png" />
                                <img style="width:32px;margin-left:-20px;" src="../assets/juxing2.png" />
                                <img style="width:32px;" src="../assets/juxing3.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div :style="{ backgroundImage: 'url(' + wenhua + ')' }"
                style="padding-bottom:30px;width:100%;background-position: center center;background-repeat: no-repeat;background-size: cover;">
                <div class="solve head-label just_center" style="padding-top: 60px;margin-top:0;">
                    <img style="width:34px;" src="../assets/sangang1.png">
                    <div style="text-align: center;margin-left:20px;margin-right:20px;font-weight:700;font-family:Microsoft YaHei;"
                        class="font_size_24">
                        汇升文化
                    </div>
                    <img style="width:34px;" src="../assets/sangang2.png">
                </div>
                <div class="solve head-label" style="margin-top:20px;">
                    <div style="width:82%;margin:0 auto;margin-top:20px;display: flex;">
                        <div style="width:50%;padding-left:5%;">
                            <!-- <div style="font-size: 20px;margin-top:20px;">「善心、专心、忠心、公心、静心」</div> -->
                            <div style="color:#3fa8c7;font-size: 38px;margin-top: 20px;margin-left: 5px;">汇升文化</div>
                            <div style="margin-top:58px;font-size: 18px;width:90%;line-height:32px;">
                                <span
                                    style="font-weight:600;">集聚全国最强大脑和行业顶尖人才</span>，秉承“一个有担当的资本，一个有深度的团队”的长期愿景，打造集健康管理、知识分享、公益担当为一体的企业文化体系
                            </div>
                            <div style="margin-top:66px;font-size: 18px;width:90%;line-height:32px;">
                                <span
                                    style="font-weight:600;">职业成长</span>：依托汇升智善金融研究院，与行业顶级专家论道同行，丰富多样化的培训体系，专业导师亲自带教，制定职业发展计划，开放式的职业上升通道，具有竞争力的薪酬激励机制。
                            </div>
                            <div style="margin-top:50px;font-size: 18px;width:90%;line-height:32px;">
                                <span
                                    style="font-weight:600;">员工福利</span>：健康的体魄是创造一切美好生活的基础，月度健康打卡挑战赛、定期徒步、环湖竞走、登山越野、球类俱乐部、福利体检、商业保险，你能想到的全都有。
                            </div>
                            <div style="margin-top:50px;font-size: 18px;width:90%;line-height:32px;">
                                <span
                                    style="font-weight:600;">公益担当</span>：苏豪汇升智善公益与腾讯公益、“担当者行动”等专业公益组织合作，以乡村儿童健康与教育为着眼点，在四川雅安芦山县、江苏宿迁泗洪县等完成17所小学110个图书角的建设。
                            </div>
                            <div style="margin: 0 auto;margin-top: 30px;margin-left: 150px;text-align:center;">
                                <div
                                    style="width: 160px;height:46px;border-radius:23px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                                    <div @click="enterHsCulture()"
                                        style="font-size:16px;font-weight:600;text-align:center;border-radius:20px;background:#3fa8c7;color:#ffffff;width:150px;height:40px;line-height:40px;cursor:pointer;">
                                        探索汇升生活
                                        <img style="vertical-align: middle;" src="../assets/jiantou.png" />
                                    </div>
                                </div>
                            </div>
                            <!-- <div style="position:absolute;top:50px;left:50%;transform: translateX(-50%);margin: 0 auto;width: 132px;height:36px;border-radius:18px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                                <div style="font-size:12px;font-weight:600;text-align:center;border-radius:15px;background:#3fa8c7;color:#ffffff;width:120px;height:30px;line-height:30px;">全部动态
                                    <img style="vertical-align: middle;" src="../assets/jiantou.png"/>
                                </div>
                            </div> -->
                        </div>
                        <div style="width:50%;">
                            <div style="text-align: center;padding-top:30px;">
                                <!-- <video-player style="width:80%;margin: 0 auto;" ref="videoPlayer1" :playsinline="true"
                                    :options="playerOptions1"></video-player> -->
                                <img style="vertical-align: middle; width:85%;" src="../assets/index_wenhua1.jpg" />
                            </div>
                            <div style="text-align: center;margin-top: 40px;">
                                <!-- <video-player style="width:80%;margin: 0 auto;" ref="videoPlayer2" :playsinline="true"
                                    :options="playerOptions2"></video-player> -->
                                <img style="vertical-align: middle; width:85%;" src="../assets/index_wenhua2.jpg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div :style="{ backgroundImage: 'url(' + chanpin + ')' }"
                style="padding-bottom:30px;width:100%;background-position: center center;background-repeat: no-repeat;background-size: cover;">
                <div class="solve head-label just_center" style="margin-top:0;padding-top: 70px;">
                    <img style="width:34px;" src="../assets/sangang1.png">
                    <div style="text-align: center;margin-left:20px;margin-right:20px;font-weight:700;"
                        class="font_size_24">
                        汇升产品
                    </div>
                    <img style="width:34px;" src="../assets/sangang2.png">
                </div>
                <div class="solve head-label" style="margin-top:20px;">
                    <div style="text-align: center;font-size:18px;">
                        <div style="margin-top:33px;">「各大权威荣誉认可、多年表现优异」的汇升产品</div>
                        <div style="margin-top:20px;font-weight:600;">中国私募金牛奖</div>
                        <div style="margin-top:10px;font-weight:600;">中国基金报英华奖</div>
                        <div style="margin-top:10px;font-weight:600;">证券时报金长江奖</div>
                        <div style="margin-top:10px;font-weight:600;">私募排排、朝阳永续、wind等多个权威机构榜单前列</div>
                        <div style="margin-top:10px;">根据不同客户风险收益目标，提供全资产、全天候、全系列的产品线定制服务</div>
                    </div>
                </div>
            </div>

            <div style="padding-bottom:0px;">
                <div style="width:91%;margin:0 auto;margin-top:38px;display: flex;">
                    <div class="pd_wrap">
                        <div class="pd_box">
                            <div class="pd_seriesBox">
                                <div class="pd_seriesItem pd_seriesItem1">
                                    <div class="pd_seriesTitle">
                                        <span>低波稳健</span>
                                    </div>
                                    <div class="pd_seriesContent">
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>低波稳健</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>泰山系列</span>
                                            </div>
                                            <div class="pd_interval"></div>
                                            <div class="pd_text3">
                                                <span>
                                                    固收、套利、中性策略
                                                </span>
                                            </div>
                                            <div class="pd_text3">
                                                <span>
                                                    低波动低回撤组合
                                                </span>
                                            </div>
                                            <div class="pd_text4">
                                                <span class="pd_textItemLabel">回测收益区间: </span>
                                                <span class="pd_textItemContent2">4 ~ 6%</span>
                                            </div>
                                            <div class="pd_text4">
                                                <span class="pd_textItemLabel">回测回撤区间: </span>
                                                <span class="pd_textItemContent">0.5 ~ 2%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pd_seriesItem pd_seriesItem2">
                                    <div class="pd_seriesTitle">
                                        <span>中波均衡</span>
                                    </div>
                                    <div class="pd_seriesContent">
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>平衡配置</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>星汇系列</span>
                                            </div>
                                            <div class="pd_interval"></div>
                                            <div class="pd_text5">
                                                <span>
                                                    以低波动资产有效防御的同时，匹配均衡的进攻性资产获取收益增强，构建高性价比的长期稳健策略组合
                                                </span>
                                            </div>
                                        </div>
                                        <div class="pd_seriesContentInterval"></div>
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>灵活配置</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>华山系列</span>
                                            </div>
                                            <div class="pd_interval"></div>
                                            <div class="pd_text5">
                                                <span>
                                                    通过全天候动态战术框架(DAA),多元配置于各类资产和细分策略，对市场不同环境灵活适配，追求收益攻守平衡
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pd_seriesItem pd_seriesItem3">
                                    <div class="pd_seriesTitle">
                                        <span>工具及定制型</span>
                                    </div>
                                    <div class="pd_seriesContent">
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>指数增强</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>天山系列</span>
                                            </div>
                                        </div>
                                        <div class="pd_verticalSpacer"></div>
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>市场中性</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>衡山系列</span>
                                            </div>
                                        </div>
                                        <div class="pd_verticalSpacer"></div>
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>主观权益</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>星睿系列</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pd_horizontalSpacer"></div>
                                    <div class="pd_seriesContent">
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>可转债组合</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>星辰系列</span>
                                            </div>
                                        </div>
                                        <div class="pd_verticalSpacer"></div>
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>CTA组合</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>嵩山系列</span>
                                            </div>
                                        </div>
                                        <div class="pd_verticalSpacer"></div>
                                        <div class="pd_seriesContentItem">
                                            <div class="pd_text1">
                                                <span>多策略弹性</span>
                                            </div>
                                            <div class="pd_text2">
                                                <span>远山系列</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="padding-bottom:50px;">
                <!-- <div style="width:91%;margin:0 auto;margin-top:38px;display: flex;">
                    <div style="width:16%;box-shadow:0px 6px 12px #dedee0;">
                        <div style="position:relative;">
                            <img style="width:100%;" src="../assets/xianjinguanli.png" >
                            <div style="position:absolute;top:50%;width: max-content;left:5%;transform: translate(0, -50%);color:#ffffff;font-size:30px;">
                                01
                            </div>
                            <div style="position:absolute;top:50%;width: max-content;left:50%;transform: translate(-50%, -50%);color:#ffffff;font-size:24px;">
                                低波动理财
                            </div>
                        </div>
                        <div style="padding:10px;position:relative;font-size:34px;">
                            <div>
                                <img style="width:100%;" src="../assets/xianjinguanli1.png" >
                            </div>
                            <div style="width:100%;text-align:center;position:absolute;top:25%;left:50%;transform: translate(-50%, -50%);color:#333333;">
                                安鑫系列
                            </div>
                            <div style="width:98%;background:#ffffff;height:10px;position:absolute;top:48%;left:0%;">
                                
                            </div>
                            <div style="width:100%;text-align:center;position:absolute;top:72%;left:50%;transform: translate(-50%, -50%);color:#333333;">
                                泰山系列
                            </div>
                        </div>
                    </div>
                    <div style="width:25%;margin-left: 1%;box-shadow:0px 6px 12px #dedee0;">
                        <div style="position:relative;">
                            <img style="width:100%;" src="../assets/quanzichan.png" >
                            <div style="position:absolute;top:50%;width: max-content;left:4%;transform: translate(0, -50%);color:#ffffff;font-size:30px;">
                                02
                            </div>
                            <div style="position:absolute;top:50%;    width: max-content;left:50%;transform: translate(-50%, -50%);color:#ffffff;font-size:24px;">
                                全资产配置型FOF
                            </div>
                        </div>
                        <div style="padding:10px;">
                            <div style="width:100%;position:relative;font-size:18px;">
                                <img style="width:100%;" src="../assets/quanzichan1.png" >
                                <div style="position:absolute;text-align: center;top:20%;left:10%;width:80px;height:30px;color:#4877cb;line-height:30px;background:rgba(123, 163, 235, 0.2);border-radius:4px 12px 4px 4px;">
                                    进取型
                                </div>
                                <div style="position:absolute;top:60%;left:11%;color:#333333;font-size:24px;">
                                    星睿系列
                                </div>
                            </div>
                            <div style="width:100%;margin-top:10px;position:relative;font-size:18px;">
                                <img style="width:100%;" src="../assets/quanzichan2.png" >
                                <div style="position:absolute;text-align: center;top:20%;left:10%;width:80px;height:30px;color:#dd8b37;line-height:30px;background:#ffe1c1;border-radius:4px 12px 4px 4px;">
                                    平衡型
                                </div>
                                <div style="position:absolute;top:60%;left:11%;color:#333333;font-size:24px;">
                                    星汇系列
                                </div>
                            </div>
                            <div style="width:100%;margin-top:10px;position:relative;font-size:18px;">
                                <img style="width:100%;" src="../assets/quanzichan3.png" >
                                <div style="position:absolute;text-align: center;top:20%;left:10%;width:80px;height:30px;color:#3db4d7;line-height:30px;background:#c7ebf5;border-radius:4px 12px 4px 4px;">
                                    稳健型
                                </div>
                                <div style="position:absolute;top:60%;left:11%;color:#333333;font-size:24px;">
                                    星辰系列
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width:34%;margin-left: 1%;box-shadow:0px 6px 12px #dedee0;">
                        <div style="position:relative;">
                            <img style="width:100%;" src="../assets/zhutixing.png" >
                            <div style="position:absolute;top:50%;width: max-content;left:3%;transform: translate(0, -50%);color:#ffffff;font-size:30px;">
                                03
                            </div>
                            <div style="position:absolute;top:50%;    width: max-content;left:50%;transform: translate(-50%, -50%);color:#ffffff;font-size:24px;">
                                主题型策略
                            </div>
                        </div>
                        <div style="padding:10px;">
                            <div style="display:flex;">
                                <div style="width:calc(50% - 7px);position:relative;">
                                    <img style="width:100%;" src="../assets/tainshan.png" >
                                    <div style="width:100%;position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);color:#333333;">
                                        <div style="margin:0 auto;font-size:18px;text-align: center;width:120px;height:30px;color:#3fa8c7;line-height:30px;background:rgba(124, 225, 255, 0.2);border-radius:4px 12px 4px 4px;">
                                            指数增强FOF
                                        </div>
                                        <div style="color:#333333;font-size:34px;text-align: center;margin-top:13px;font-family:PingFangSC-Medium;">
                                            天山系列
                                        </div>
                                    </div>
                                </div>
                                <div style="width:calc(50% - 7px);margin-left:14px;position:relative;">
                                    <img style="width:100%;" src="../assets/songshan.png" >
                                    <div style="width:100%;position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);color:#333333;">
                                        <div style="margin:0 auto;font-size:18px;text-align: center;width:120px;height:30px;color:#4877cb;line-height:30px;background:rgba(123, 163, 235, 0.2);border-radius:4px 12px 4px 4px;">
                                            管理期货FOF
                                        </div>
                                        <div style="color:#333333;font-size:34px;text-align: center;margin-top:13px;font-family:PingFangSC-Medium;">
                                            嵩山系列
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top:10px;display:flex;">
                                <div style="width:calc(50% - 7px);position:relative;">
                                    <img style="width:100%;" src="../assets/huashan.png" >
                                    <div style="width:100%;position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);color:#333333;">
                                        <div style="margin:0 auto;font-size:18px;text-align: center;width:120px;height:30px;color:#ff9916;line-height:30px;background:rgba(255, 153, 22, 0.2);border-radius:4px 12px 4px 4px;">
                                            灵活进取FOF
                                        </div>
                                        <div style="color:#333333;font-size:34px;text-align: center;margin-top:13px;font-family:PingFangSC-Medium;">
                                            华山系列
                                        </div>
                                    </div>
                                </div>
                                <div style="width:calc(50% - 7px);margin-left:14px;position:relative;">
                                    <img style="width:100%;" src="../assets/taishan.png" >
                                    <div style="width:100%;position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);color:#333333;">
                                        <div style="margin:0 auto;font-size:18px;text-align: center;width:120px;height:30px;color:#ff6f4e;line-height:30px;background:rgba(255, 111, 78, 0.2);border-radius:4px 12px 4px 4px;">
                                            雪球产品
                                        </div>
                                        <div style="color:#333333;font-size:34px;text-align: center;margin-top:13px;font-family:PingFangSC-Medium;">
                                            雪山系列
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width:22%;margin-left:1%;box-shadow:0px 6px 12px #dedee0;">
                        <div style="position:relative;">
                            <img style="width:100%;" src="../assets/xingxiang.png" >
                            <div style="position:absolute;top:50%;width: max-content;left:4%;transform: translate(0, -50%);color:#ffffff;font-size:30px;">
                                04
                            </div>
                            <div style="position:absolute;top:50%;    width: max-content;left:50%;transform: translate(-50%, -50%);color:#ffffff;font-size:24px;">
                                星享定制系列
                            </div>
                        </div>
                        <div style="padding:10px;position:relative;font-size:18px;">
                            <div>
                                <img style="width:100%;" src="../assets/xingxiang1.png" >
                            </div>
                            <div style="font-size:20px;width:80%;text-align:center;position:absolute;top:50%;left:50%;transform: translate(-50%, -50%);color:#333333;">
                                <div style="padding-bottom:20px;border-bottom:1px solid #b9c5e1;">
                                    <div style="text-align:justify;display:inline-block;line-height:35px;">
                                        <span style="display:inline-block;margin-right:10px;width:10px;border-radius:5px;height:10px;background:linear-gradient(180deg,#c3dbff 0%,#a5b7d8 100%);"></span>
                                        根据客户收益风险预期及流动性需求进行专户定制
                                    </div>
                                </div>
                                <div style="padding-top:20px;padding-bottom:20px;border-bottom:1px solid #b9c5e1;">
                                    <div style="text-align:justify;display:inline-block;line-height:35px;">
                                        <span style="display:inline-block;margin-right:10px;width:10px;border-radius:5px;height:10px;background:linear-gradient(180deg,#c3dbff 0%,#a5b7d8 100%);"></span>
                                        共享核心资产池，提供单策略组合，可随心搭配
                                    </div>
                                </div>
                                <div style="padding-top:20px;">
                                    <div style="text-align:justify;display:inline-block;line-height:35px;">
                                        <span style="display:inline-block;margin-right:10px;width:10px;border-radius:5px;height:10px;background:linear-gradient(180deg,#c3dbff 0%,#a5b7d8 100%);"></span>
                                        提供完善的资产配置贴身服务，分享核心投研理念和系统支持
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div style="width:91%;margin:0 auto;margin-top:15px;padding-bottom:30px;box-shadow:0px 6px 12px #dedee0;">
                    <div style="display:flex;">
                        <div style="width:25%;position:relative;border-right:1px solid #dfdfdf;margin-top:70px;">
                            <common-echarts :option="option" style="width:100%;height:250px;" ref="echarts1"></common-echarts>
                            <div style="position:absolute;top:-20px;right:20px;font-family:Microsoft YaHei;color:#333333;font-size:24px;">
                                现金管理型
                                <div style="font-size:14px;margin-top:60px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#fbc9aa;"></span>市场中性 <span style="margin-left:40px;">10%</span>
                                </div>
                                <div style="font-size:14px;margin-top:20px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#bbe3fd;"></span>套利策略 <span style="margin-left:40px;">30%</span>
                                </div>
                                <div style="font-size:14px;margin-top:20px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#decefe;"></span>固收策略 <span style="margin-left:40px;">60%</span>
                                </div>
                            </div>
                            <div style="color: #999999;margin-left:2%;font-size:14px;height:36px;margin-top:25px;line-height:36px;text-align:center;background:#f7f7f7;border-radius:18px;">
                                <span>业绩回测年化收益率: <span style="color:#333333;margin-right:3px;">4%-6%</span></span> | <span style="margin-left:3px;">业绩回测回撤区间：<span style="color:#333333;">0.5%-1.5%</span></span>
                            </div>
                        </div>
                        <div style="width:25%;position:relative;border-right:1px solid #dfdfdf;margin-top:70px;">
                            <common-echarts :option="option1" style="width:100%;height:250px;" ref="echarts2"></common-echarts>
                            <div style="position:absolute;top:-20px;right:20px;font-family:Microsoft YaHei;color:#333333;font-size:24px;">
                                稳健型FOF
                                <div style="font-size:14px;margin-top:40px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#c2f3f5;"></span>权益多头 <span style="margin-left:40px;">15%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#f6e0a9;"></span>管理期货 <span style="margin-left:40px;">20%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#fbc9aa;"></span>市场中性 <span style="margin-left:40px;">25%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#bbe3fd;"></span>套利策略 <span style="margin-left:40px;">20%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#decefe;"></span>固收策略 <span style="margin-left:40px;">20%</span>
                                </div>
                            </div>
                            <div style="color: #999999;margin-left:2%;font-size:14px;margin-top:25px;height:36px;line-height:36px;text-align:center;background:#f7f7f7;border-radius:18px;">
                                <span>业绩回测年化收益率: <span style="color:#333333;margin-right:3px;">6%-8%</span></span> | <span style="margin-left:3px;">业绩回测回撤区间：<span style="color:#333333;">1%-3%</span></span>
                            </div>
                        </div>
                        <div style="width:25%;position:relative;border-right:1px solid #dfdfdf;margin-top:70px;">
                            <common-echarts :option="option2" style="width:100%;height:250px;" ref="echarts3"></common-echarts>
                            <div style="position:absolute;top:-20px;right:20px;font-family:Microsoft YaHei;color:#333333;font-size:24px;">
                                平衡型FOF
                                <div style="font-size:14px;margin-top:40px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#c2f3f5;"></span>权益多头 <span style="margin-left:40px;">25%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#f6e0a9;"></span>管理期货 <span style="margin-left:40px;">30%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#fbc9aa;"></span>市场中性 <span style="margin-left:40px;">20%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#bbe3fd;"></span>套利策略 <span style="margin-left:40px;">20%</span>
                                </div>
                                <div style="font-size:14px;margin-top:15px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#decefe;"></span>固收策略 <span style="margin-left:40px;">5%</span>
                                </div>
                            </div>
                            <div style="color: #999999;margin-left:2%;font-size:14px;margin-top:25px;height:36px;line-height:36px;text-align:center;background:#f7f7f7;border-radius:18px;">
                                <span>业绩回测年化收益率: <span style="color:#333333;margin-right:3px;">8%-12%</span></span> | <span style="margin-left:3px;">业绩回测回撤区间：<span style="color:#333333;">2%-5%</span></span>
                            </div>
                        </div>
                        <div style="width:25%;position:relative;margin-top:70px;">
                            <common-echarts :option="option3" style="width:100%;height:250px;" ref="echarts4"></common-echarts>
                            <div style="position:absolute;top:-20px;right:20px;font-family:Microsoft YaHei;color:#333333;font-size:24px;">
                                进取型FOF
                                <div style="font-size:14px;margin-top:50px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#c2f3f5;"></span>权益多头 <span style="margin-left:40px;">35%</span>
                                </div>
                                <div style="font-size:14px;margin-top:20px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#f6e0a9;"></span>管理期货 <span style="margin-left:40px;">30%</span>
                                </div>
                                <div style="font-size:14px;margin-top:20px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#fbc9aa;"></span>市场中性 <span style="margin-left:40px;">20%</span>
                                </div>
                                <div style="font-size:14px;margin-top:20px;color:#999999;">
                                    <span style="display:inline-block;width:6px;height:6px;border-radius:3px;margin-right:9px;background:#bbe3fd;"></span>套利策略 <span style="margin-left:40px;">15%</span>
                                </div>
                            </div>
                            <div style="color: #999999;margin-left:2%;font-size:14px;margin-top:25px;height:36px;line-height:36px;text-align:center;background:#f7f7f7;border-radius:18px;">
                                <span>业绩回测年化收益率: <span style="color:#333333;margin-right:3px;">10%-20%</span></span> | <span style="margin-left:3px;">业绩回测回撤区间：<span style="color:#333333;">4%-8%</span></span>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top:40px;text-align:center;font-family:PingFangSC-Regular;color:#666666;font-size:14px;">*收益目标不代表承诺收益，不代表产品未来收益</div>
                </div> -->
            </div>

            <div :style="{ backgroundImage: 'url(' + toujiao + ')' }"
                style="width:100%;margin-top:40px;padding-bottom:60px;width:100%;background-position: center center;background-repeat: no-repeat;background-size: cover;">
                <div class="solve head-label just_center" style="padding-top: 70px;">
                    <img style="width:34px;" src="../assets/sangang1.png">
                    <div style="text-align: center;margin-left:20px;margin-right:20px;font-weight:700;"
                        class="font_size_24">
                        汇升投教
                    </div>
                    <img style="width:34px;" src="../assets/sangang2.png">
                </div>

                <!-- :style="{backgroundImage: 'url('+bgImage3+')'}" -->
                <!-- background-position: center 0;background-repeat: no-repeat;background-size: cover; -->
                <div class="solve head-label" style="margin-top:50px;">
                    <div style="width:80%;margin:0 auto;margin-top:20px;display: flex;">
                        <div style="width:55%;padding-left:5%;">
                            <div style="font-size: 20px;">「金融为善 、生生不息」</div>
                            <div style="color:#3fa8c7;font-size: 38px;margin-top: 20px;margin-left: 5px;">汇升投资者教育基地
                            </div>
                            <div
                                style="text-align: justify;margin-top:30px;font-size: 20px;width:90%;line-height:36px;">
                                晚清金陵著名富商兼慈善家蒋春华一族以“公益为人生分内事”为家规家训，蒋家后人深受家风浸染，向善向美，人才辈出。汇升投资者教育基地选址于老门东内唯一江苏省文物保护单位——蒋寿山故居，与秦淮区人民政府合作共建，将文物建筑的保护与活化利用进行有机融合，旨在以历史文化传承和金融公益传播为使命，继承先辈遗风，以史为鉴，继往开来。
                            </div>
                            <div
                                style="text-align: justify;margin-top:40px;font-size: 20px;width:90%;line-height:36px;">
                                以行业使命担当践行投教初心，携手行业向善的力量普及金融知识，致力于打造一个金融公益文化的展示窗口和一张南京文化特色的城市名片，共同构建社会责任投资新生态，助力南京文化名城建设，谱写中国投教事业新篇章。
                            </div>
                            <div style="margin: 0 auto;margin-top: 60px;margin-left: 150px;text-align:center;">
                                <div
                                    style="width: 160px;height:46px;border-radius:23px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                                    <div @click="enterHsEducate()"
                                        style="font-size:15px;font-weight:600;text-align:center;border-radius:20px;background:#3fa8c7;color:#ffffff;width:150px;height:40px;line-height:40px;cursor:pointer;">
                                        走进汇升投教
                                        <img style="vertical-align: middle;" src="../assets/jiantou.png" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width:45%;">
                            <div style="text-align: center;margin-top:16px;">
                                <!-- <video-player style="width:100%;" ref="videoPlayer" :playsinline="true"
                                    :options="playerOptions"></video-player> -->
                                <img style="vertical-align: middle; width:100%;" src="../assets/index_toujiao1.jpg" />


                                <div style="font-size:18px;padding-top:20px;line-height:30px;text-align: left;">
                                    <!-- <img style="width:26px;vertical-align: sub;margin-right:5px;" src="../assets/juxing2.png"/> -->
                                    <img style="width:26px;vertical-align: sub;" src="../assets/juxing1.png" />
                                    <img style="width:26px;vertical-align: sub;margin-left:-16px;"
                                        src="../assets/juxing2.png" />
                                    <img style="width:26px;vertical-align: sub;margin-right:5px;"
                                        src="../assets/juxing3.png" />
                                    邀您一起走进投教基地，了解投教基地的建设初心和愿景......
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding-top: 80px;padding-bottom:80px;display:flex;">
                <div style="width:49%;text-align:right;">
                    <div style="width:80%;margin-left:19%;position:relative;">
                        <img style="width:100%;z-index:100;" @mouseenter="onEnterNJ" @mouseleave="onLeaveNJ"
                            :src="nanjing ? njSrc0 : njSrc">
                        <div style="width:100%;z-index:0;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"
                            @mouseenter="onEnterNJ" @mouseleave="onLeaveNJ">
                            <div v-if="!nanjing" style="font-size:48px;color:#ffffff;text-align:center;">
                                南京
                            </div>
                            <div v-if="nanjing" style="font-size:48px;color:#333333;font-weight:600;text-align:center;">
                                南京
                            </div>
                            <div v-if="!nanjing" style="width:60%;margin:0 auto;margin-left:25%;">
                                <div style="text-align:justify;margin-top:15px;font-size:22px;color:#ffffff;">
                                    地址：南京市秦淮区户部街15号
                                </div>
                                <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                    兴业大厦21楼
                                </div>
                                <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                    电话：025-86828106
                                </div>
                                <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                    邮箱：wisdom@highhope.com
                                </div>
                            </div>
                            <div v-if="nanjing"
                                style="margin-top:15px;font-size:46px;color:#333333;font-weight:600;text-align:center;">
                                NANJING
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width:49%;text-align:left;margin-left:1%;">
                    <div style="width:80%;margin-left:1%;position:relative;">
                        <img style="width:100%;z-index:100;" @mouseenter="onEnterSH" @mouseleave="onLeaveSH"
                            :src="shanghai ? shSrc : shSrc0">
                        <div @mouseenter="onEnterSH" @mouseleave="onLeaveSH"
                            style="width:100%;z-index:0;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);">
                            <div v-if="shanghai"
                                style="font-size:48px;color:#ffffff;font-weight:600;text-align:center;">
                                上海
                            </div>
                            <div v-if="!shanghai"
                                style="font-size:48px;color:#333333;font-weight:600;text-align:center;">
                                上海
                            </div>
                            <div v-if="shanghai" style="width:60%;margin:0 auto;margin-left:25%;">
                                <div style="text-align:justify;margin-top:15px;font-size:22px;color:#ffffff;">
                                    地址：上海市虹口区东大名路501号
                                </div>
                                <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                    白玉兰广场3707室
                                </div>
                                <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                    电话：025-86828106
                                </div>
                                <div style="text-align:justify;margin-top:3px;font-size:22px;color:#ffffff;">
                                    邮箱：wisdom@highhope.com
                                </div>
                            </div>
                            <div v-if="!shanghai"
                                style="margin-top:15px;font-size:46px;color:#333333;font-weight:600;text-align:center;">
                                SHANGHAI
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <el-dialog title="合格投资者认证" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false"
            @before-close="reject" :center="true">
            <div class="hege"
                style="width:86%;margin:0 auto;text-align:justify;padding-left:5%;padding-bottom:10px;padding-right:5%;font-size:16px;line-height: 33px;height:490px;overflow-y:auto;">
                在继续浏览本公司网站前，请您确认您或您所代表的机构是一名“合格投资者”。根据我国《私募投资基金监督管理暂行办法》的规定，合格投资者的标准如下：
                <br />
                一、私募基金的合格投资者是指具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元
                且符合下列相关标准的单位和个人：
                <br />
                1、净资产不低于1000万元的单位；
                <br />
                2、金融资产不低于300万元或者最近三年个人年均收入不低于50万元的个人。前款所称金融资产包括银行存款、
                股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。
                <br />
                二、下列投资者视为合格投资者：
                <br />
                1、社会保障基金、企业年金等养老基金、慈善基金等社会公益基金；
                <br />
                2、依法设立并在基金业协会备案的投资计划；
                <br />
                3、投资于所管理私募基金的私募基金管理人及其从业人员；
                <br />
                4、中国证监会规定的其他投资者。
                <br />
                如果您继续访问或使用本网站及其所载资料，即表明您声明及保证您或您所代表的机构为“合格投资者”，并将遵守对您适用的司法区域的有关法律及法规，同意并接受以下条款及相关约束。如果您不符合“合格投资者”标准或不同意下列条款及相关约束，请勿继续访问或使用本网站及其所载信息及资料。
                <br />
                投资涉及风险，投资者应详细审阅产品的发售文件以获取进一步资料，了解有关投资所涉及的风险因素，并寻求适当的专业投资和咨询意见。产品净值及其收益存在涨跌可能，过往的产品业绩数据并不预示产品未来的业绩表现。本网站所提供的资料并非投资建议或咨询意见，投资者不应依赖本网站所提供的信息及资料作出投资决策。
                <br />
                与本网站所载信息及资料有关的所有版权、专利权、知识产权及其他产权均为本公司所有。本公司概不向浏览该资料人士发出、转让或以任何方式转移任何种类的权利。
            </div>
            <div style="width:86%;margin:0 auto;border-bottom:1px solid #cccccc;padding-top:30px;">

            </div>
            <div slot="footer" class="dialog-footer" style="font-size: 18px;cursor: pointer;">
                <div
                    style="margin: 0 auto;width: 176px;height:50px;border-radius:25px;border:1px solid #d0f4ff;justify-content: center;display: flex;align-items: center;">
                    <div @click="accept"
                        style="font-size:17px;font-weight:600;text-align:center;border-radius:21px;background:#3fa8c7;color:#ffffff;width:160px;height:42px;line-height:42px;cursor:pointer;">
                        接 受
                    </div>
                </div>
                <div style="margin: 0 auto;margin-top:15px;border-bottom:2px solid #8e8686;color: #858282;padding-bottom:3px;width:50px;margin-bottom:10px;"
                    @click="reject">放 弃</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as echarts from "echarts";
import CommonEcharts from "./echarts.vue";
export default {
    name: 'Index',
    components: {
        CommonEcharts,
    },
    data() {
        return {
            sliders: [],
            nanjing: false,
            dialogVisible: false,
            showVideo: false,
            njSrc: require('../assets/nanjing.png'),
            njSrc0: require('../assets/nanjing0.png'),
            shanghai: false,
            peizhi: require('../assets/peizhitixi.jpg'),
            wenhua: require('../assets/wenhua.jpg'),
            toujiao: require('../assets/shouyetoujiao.png'),
            chanpin: require('../assets/chanpin.png'),
            shSrc: require('../assets/shanghai.png'),
            shSrc0: require('../assets/shanghai0.png'),
            bgImage: require('../assets/juanmahua.png'),
            bgImage2: require('../assets/zichanpeizhi_bg.jpg'),
            bgImage3: require('../assets/huishengtoujiao_bg.jpg'),
            playerOptions0: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                muted: true, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    src: 'https://hhhsdemo.oss-cn-shanghai.aliyuncs.com/website/shipin.mp4', // require('../assets/shipin.mp4'), // 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4',  // 路径
                    // type: 'video/mp4'  // 类型
                    type: "video/mp4",
                }],
                controls: false,
                poster: "封面路径", //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true  //全屏按钮
                }
            },
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{ // 'https://hhhsdemo.oss-cn-shanghai.aliyuncs.com/website/toujiao.mp4'
                    src: require('../assets/toujiao2.mp4'), // 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4',  // 路径
                    // type: 'video/mp4'  // 类型
                    type: "video/mp4",
                }],
                poster: "封面路径", //你的封面地址
            },
            playerOptions1: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    src: 'https://hhhsdemo.oss-cn-shanghai.aliyuncs.com/website/funvjie.mp4', // require('../assets/funvjie.mp4'), // 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4',  // 路径
                    // type: 'video/mp4'  // 类型
                    type: "video/mp4",
                }],
                poster: '',
                // poster: require('../assets/huishengdongtai1.png'), //你的封面地址
            },
            playerOptions2: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{ // https://hhhsdemo.oss-cn-shanghai.aliyuncs.com/website/tuanjian.mp4
                    src: require('../assets/tuanjian2.mp4'), // 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4',  // 路径
                    // type: 'video/mp4'  // 类型
                    type: "video/mp4",
                }],
                poster: "封面路径", //你的封面地址
                // poster: require('../assets/huishengdongtai1.png'), //你的封面地址
            },
            company: [
                "企业从事于：互联网整合营销，互联网软件开发，微信公众号，小程序，微商城开发，提供技术支持，是所创业型服务研发公司。",
                "核心理念：打造移动电子商务平台 ，提供一键式部署，实现简单可靠稳定的商务平台。",
                "团队作风：我们来自不同地区，因梦想相聚，组建团队，每个团队成员如同人的五官，缺一不可。",
                "企业精神：以实力为盾，自信为矛。我们坚信成功靠朋友，成长靠对手，成就靠团体。",
            ],
            option: {
                // legend: {
                //     orient: 'vertical',
                //     x: 'right',
                //     y: 'center',
                //     formatter: function (name) {
                //         // 获取legend显示内容
                //         let data = [
                //             { value: 10, name: '市场中性' },
                //             { value: 30, name: '套利策略' },
                //             { value: 60, name: '固收策略' }
                //         ]
                //         let total = 0;
                //         let tarValue = 0;
                //         for (let i = 0, l = data.length; i < l; i++) {
                //             total += data[i].value;
                //             if (data[i].name == name) {
                //             tarValue = data[i].value;
                //             }
                //         }
                //         let p = (tarValue / total * 100).toFixed(0);
                //         return name + ' ' + ' ' + p + '%';
                //     },
                //     data: ['市场中性','套利策略', '固收策略']
                // },
                grid: {
                    top: '0px',
                    left: '10px',
                    right: '10px',
                    bottom: '40px' //距离下边的距离
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['45%', '70%'],
                        center: ['32%', '53%'],
                        avoidLabelOverlap: false,
                        // itemStyle: {
                        //     borderRadius: 6,
                        //     borderColor: '#fff',
                        //     borderWidth: 2
                        // },
                        itemStyle: {
                            normal: {
                                // borderColor: 'rgba(15, 23, 27, 1.00)',
                                borderRadius: 6,
                                borderColor: '#fff',
                                borderWidth: 2,
                                color: function (params) {
                                    var colorList = [
                                        {
                                            c1: 'rgba(244, 153, 110, 0.7)',
                                            c2: 'rgba(252, 205, 159, 0.7)'
                                        },
                                        {
                                            c1: 'rgba(140, 192, 248, 0.7)',
                                            c2: 'rgba(172, 238, 254, 0.7)'
                                        },
                                        {
                                            c1: 'rgba(176, 159, 252, 0.7)',
                                            c2: 'rgba(252, 221, 255, 0.7)'
                                        },
                                    ]
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                                        offset: 0,
                                        color: colorList[params.dataIndex].c1
                                    }, {
                                        offset: 1,
                                        color: colorList[params.dataIndex].c2
                                    }])

                                }
                            }
                        },
                        label: {
                            show: true,
                            fontSize: 20,
                            color: '#333333',
                            fontWeight: 500,
                            position: 'center',
                            formatter: function () {
                                return '安鑫系列' // 设置圆饼图中间文字排版
                            }
                        },
                        // label: {
                        //     normal: {
                        //         show: false,
                        //         position: 'center',
                        //         formatter: function(data){ // 设置圆饼图中间文字排版
                        //             return data.value+"\n"+"用户数"
                        //         }
                        //     }
                        // }
                        // emphasis: {
                        //     label: {
                        //     show: true,
                        //     fontSize: 40,
                        //     fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 10, name: '市场中性' },
                            { value: 30, name: '套利策略' },
                            { value: 60, name: '固收策略' }
                        ]
                    }
                ]
            },
            option1: {
                // legend: {
                //     orient: 'vertical',
                //     x: 'right',
                //     y: 'center',
                //     formatter: function (name) {
                //         // 获取legend显示内容
                //         let data = [
                //             { value: 15, name: '权益多头' },
                //             { value: 20, name: '管理期货' },
                //             { value: 25, name: '市场中性' },
                //             { value: 20, name: '套利策略' },
                //             { value: 20, name: '固收策略' }
                //         ]
                //         let total = 0;
                //         let tarValue = 0;
                //         for (let i = 0, l = data.length; i < l; i++) {
                //             total += data[i].value;
                //             if (data[i].name == name) {
                //             tarValue = data[i].value;
                //             }
                //         }
                //         let p = (tarValue / total * 100).toFixed(0);
                //         return name + ' ' + ' ' + p + '%';
                //     },
                //     data: ['权益多头','管理期货', '市场中性', '套利策略', '固收策略']
                // },
                grid: {
                    top: '0px',
                    left: '10px',
                    right: '10px',
                    bottom: '20px' //距离下边的距离
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['45%', '70%'],
                        center: ['32%', '53%'],
                        avoidLabelOverlap: false,
                        // itemStyle: {
                        //     borderRadius: 6,
                        //     borderColor: '#fff',
                        //     borderWidth: 2
                        // },
                        itemStyle: {
                            normal: {
                                // borderColor: 'rgba(15, 23, 27, 1.00)',
                                borderRadius: 6,
                                borderColor: '#fff',
                                borderWidth: 2,
                                color: function (params) {
                                    var colorList = [
                                        {
                                            c1: 'rgba(225, 253, 255, 0.7)',
                                            c2: 'rgba(150, 245, 249, 0.7)'
                                        },
                                        {
                                            c1: 'rgba(246, 228, 183, 0.7)',
                                            c2: 'rgba(238, 193, 86, 0.7)'
                                        },
                                        {
                                            c1: 'rgba(252, 205, 159, 0.7)',
                                            c2: 'rgba(244, 153, 110, 0.7)'
                                        },
                                        {
                                            c1: 'rgba(140, 192, 248, 0.7)',
                                            c2: 'rgba(172, 238, 254, 0.7)'
                                        },
                                        {
                                            c1: 'rgba(176, 159, 252, 0.7)',
                                            c2: 'rgba(252, 221, 255, 0.7)'
                                        }]
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                                        offset: 0,
                                        color: colorList[params.dataIndex].c1
                                    }, {
                                        offset: 1,
                                        color: colorList[params.dataIndex].c2
                                    }])

                                }
                            }
                        },
                        label: {
                            show: true,
                            fontSize: 20,
                            color: '#333333',
                            fontWeight: 500,
                            position: 'center',
                            formatter: function () {
                                return '星辰系列' // 设置圆饼图中间文字排版
                            }
                        },
                        // label: {
                        //     normal: {
                        //         show: false,
                        //         position: 'center',
                        //         formatter: function(data){ // 设置圆饼图中间文字排版
                        //             return data.value+"\n"+"用户数"
                        //         }
                        //     }
                        // }
                        // emphasis: {
                        //     label: {
                        //     show: true,
                        //     fontSize: 40,
                        //     fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 15, name: '权益多头' },
                            { value: 20, name: '管理期货' },
                            { value: 25, name: '市场中性' },
                            { value: 20, name: '套利策略' },
                            { value: 20, name: '固收策略' }
                        ]
                    }
                ]
            },
            option2: {
                // legend: {
                //     orient: 'vertical',
                //     x: 'right',
                //     y: 'center',
                //     formatter: function (name) {
                //         // 获取legend显示内容
                //         let data = [
                //             { value: 25, name: '权益多头' },
                //             { value: 30, name: '管理期货' },
                //             { value: 20, name: '市场中性' },
                //             { value: 20, name: '套利策略' },
                //             { value: 5, name: '固收策略' }
                //         ]
                //         let total = 0;
                //         let tarValue = 0;
                //         for (let i = 0, l = data.length; i < l; i++) {
                //             total += data[i].value;
                //             if (data[i].name == name) {
                //             tarValue = data[i].value;
                //             }
                //         }
                //         let p = (tarValue / total * 100).toFixed(0);
                //         return name + ' ' + ' ' + p + '%';
                //     },
                //     data: ['权益多头','管理期货', '市场中性', '套利策略', '固收策略']
                // },
                grid: {
                    top: '0px',
                    left: '10px',
                    right: '10px',
                    bottom: '20px' //距离下边的距离
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['45%', '70%'],
                        center: ['32%', '53%'],
                        avoidLabelOverlap: false,
                        // itemStyle: {
                        //     borderRadius: 6,
                        //     borderColor: '#fff',
                        //     borderWidth: 2
                        // },
                        itemStyle: {
                            normal: {
                                // borderColor: 'rgba(15, 23, 27, 1.00)',
                                borderRadius: 6,
                                borderColor: '#fff',
                                borderWidth: 2,
                                color: function (params) {
                                    var colorList = [
                                        {
                                            c1: 'rgba(233, 254, 255, 1)',
                                            c2: 'rgba(181, 248, 251, 1)'
                                        },
                                        {
                                            c1: 'rgba(248, 236, 203, 1)',
                                            c2: 'rgba(244, 213, 140, 1)'
                                        },
                                        {
                                            c1: 'rgba(248, 184, 154, 1)',
                                            c2: 'rgba(254, 221, 188, 1)'
                                        },
                                        {
                                            c1: 'rgba(183, 220, 255, 1)',
                                            c2: 'rgba(194, 238, 255, 1)'
                                        },
                                        {
                                            c1: 'rgba(201, 188, 253, 1)',
                                            c2: 'rgba(247, 227, 255, 1)'
                                        }]
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                                        offset: 0,
                                        color: colorList[params.dataIndex].c1
                                    }, {
                                        offset: 1,
                                        color: colorList[params.dataIndex].c2
                                    }])

                                }
                            }
                        },
                        label: {
                            show: true,
                            fontSize: 20,
                            color: '#333333',
                            fontWeight: 500,
                            position: 'center',
                            formatter: function () {
                                return '星汇系列' // 设置圆饼图中间文字排版
                            }
                        },
                        // label: {
                        //     normal: {
                        //         show: false,
                        //         position: 'center',
                        //         formatter: function(data){ // 设置圆饼图中间文字排版
                        //             return data.value+"\n"+"用户数"
                        //         }
                        //     }
                        // }
                        // emphasis: {
                        //     label: {
                        //     show: true,
                        //     fontSize: 40,
                        //     fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 25, name: '权益多头' },
                            { value: 30, name: '管理期货' },
                            { value: 20, name: '市场中性' },
                            { value: 20, name: '套利策略' },
                            { value: 5, name: '固收策略' }
                        ]
                    }
                ]
            },
            option3: {
                // legend: {
                //     orient: 'vertical',
                //     x: 'right',
                //     y: 'center',
                //     formatter: function (name) {
                //         // 获取legend显示内容
                //         let data = [
                //             { value: 35, name: '权益多头' },
                //             { value: 30, name: '管理期货' },
                //             { value: 20, name: '市场中性' },
                //             { value: 15, name: '套利策略' }
                //         ]
                //         let total = 0;
                //         let tarValue = 0;
                //         for (let i = 0, l = data.length; i < l; i++) {
                //             total += data[i].value;
                //             if (data[i].name == name) {
                //             tarValue = data[i].value;
                //             }
                //         }
                //         let p = (tarValue / total * 100).toFixed(0);
                //         return name + ' ' + ' ' + p + '%';
                //     },
                //     data: ['权益多头','管理期货', '市场中性', '套利策略', '固收策略']
                // },
                grid: {
                    top: '0px',
                    left: '10px',
                    right: '10px',
                    bottom: '20px' //距离下边的距离
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['45%', '70%'],
                        center: ['32%', '53%'],
                        avoidLabelOverlap: false,
                        // itemStyle: {
                        //     borderRadius: 6,
                        //     borderColor: '#fff',
                        //     borderWidth: 2
                        // },
                        itemStyle: {
                            normal: {
                                // borderColor: 'rgba(15, 23, 27, 1.00)',
                                borderRadius: 6,
                                borderColor: '#fff',
                                borderWidth: 2,
                                color: function (params) {
                                    var colorList = [
                                        {
                                            c1: 'rgba(233, 254, 255, 1)',
                                            c2: 'rgba(184, 248, 251, 1)'
                                        },
                                        {
                                            c1: 'rgba(248, 236, 203, 1)',
                                            c2: 'rgba(244, 213, 140, 1)'
                                        },
                                        {
                                            c1: 'rgba(248, 184, 154, 1)',
                                            c2: 'rgba(253, 217, 184, 1)'
                                        },
                                        {
                                            c1: 'rgba(183, 220, 255, 1)',
                                            c2: 'rgba(193, 237, 255, 1)'
                                        }]
                                    return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                                        offset: 0,
                                        color: colorList[params.dataIndex].c1
                                    }, {
                                        offset: 1,
                                        color: colorList[params.dataIndex].c2
                                    }])

                                }
                            }
                        },
                        label: {
                            show: true,
                            fontSize: 20,
                            color: '#333333',
                            fontWeight: 500,
                            position: 'center',
                            formatter: function () {
                                return '星睿系列' // 设置圆饼图中间文字排版
                            }
                        },
                        // label: {
                        //     normal: {
                        //         show: false,
                        //         position: 'center',
                        //         formatter: function(data){ // 设置圆饼图中间文字排版
                        //             return data.value+"\n"+"用户数"
                        //         }
                        //     }
                        // }
                        // emphasis: {
                        //     label: {
                        //     show: true,
                        //     fontSize: 40,
                        //     fontWeight: 'bold'
                        //     }
                        // },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: 35, name: '权益多头' },
                            { value: 30, name: '管理期货' },
                            { value: 20, name: '市场中性' },
                            { value: 15, name: '套利策略' }
                        ]
                    }
                ]
            },
            carousel_height: '550px',
        }
    },
    methods: {
        accept() {
            this.dialogVisible = false
            this.showVideo = true

            sessionStorage.setItem('renzheng', '1')
            // this.videoPlay = true
        },
        reject() {
            this.dialogVisible = false
            setTimeout(() => {
                this.dialogVisible = true
            }, 600)
        },
        onPlayerEnd() {
            this.showVideo = false

            setTimeout(() => {
                const ele = document.getElementById('imgBox')
                const sty = document.defaultView.getComputedStyle(ele, null)
                const l = parseFloat(sty.left)
                const w = parseFloat(sty.width)
                const h = parseFloat(sty.height)
                const t = parseFloat(sty.top)

                const logoBkEle = document.getElementById('logoBox')


                window.onscroll = function () {
                    //为了保证兼容性，这里取两个值，哪个有值取哪一个
                    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let p = scrollTop / 925
                    p = p > 1 ? 1 : p

                    const newTop = t - ((t - 0.6 * 97.36) * p)
                    const newLeft = l - ((l - 1.5 * 97.36) * p)
                    const newWidth = w - ((w - 1.52 * 97.36) * p)
                    const newHeight = h - ((h - 0.32 * 97.36) * p)

                    ele.style.top = newTop + 'px'
                    ele.style.left = newLeft + 'px'
                    ele.style.width = newWidth + 'px'
                    ele.style.height = newHeight + 'px'
                    // ele.style.opacity = 1 - p


                    if (p === 1) {
                        ele.style.opacity = 0
                        // logoBkEle.style.cssText = 'mix-blend-mode: normal'
                        logoBkEle.style.opacity = 0
                    } else {
                        ele.style.opacity = 1
                        logoBkEle.style.opacity = 1
                        // logoBkEle.style.cssText = 'mix-blend-mode: screen'
                    }
                    // logoBkEle.style.opacity = 0 // 0.9 + p * 0.1

                    console.log(scrollTop, p.toFixed(2), newTop.toFixed(2), newLeft.toFixed(2), newWidth.toFixed(2), newHeight.toFixed(2))
                }
            }, 10)
            // console.log(4)
            // console.log(v)
        },
        onEnterNJ() {
            this.nanjing = true
        },
        onLeaveNJ() {
            this.nanjing = false
        },
        onEnterSH() {
            this.shanghai = true
        },
        onLeaveSH() {
            this.shanghai = false
        },
        knowMore() {
            // 走进汇升
        },
        enterHsEducate() {
            this.$router.push({ name: "hsInvestEducation" });
        },
        enterHsCulture() {
            this.$router.push({ name: "HsCulture" });
        },
        enterHs() {
            this.$router.push({ name: "EnterHS" });
        },
        // findvideocover() {
        //     setTimeout(() => {
        //         const element = document.getElementById('videoPlayer');
        //         let video = element.firstChild.firstChild;
        //         //创建canvas对象
        //         const canvas = document.createElement('canvas');
        //         canvas.width = '448';
        //         canvas.height = '252';
        //         this.$nextTick(() => {
        //         // 利用canvas对象方法绘图
        //         canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        //         // 转换成base64形式
        //         const dataURL = canvas.toDataURL('image/png'); // 这个就是图片的base64
        //         //上传到oss
        //         let bimBlob = this.dataURItoBlob(dataURL);
        //         OSSUPLOAD(
        //             this.$cookies.get('projectId'),
        //             bimBlob,
        //             this.fileName + `${new Date().toLocaleString()}`,
        //             SYSTERMNAME.lprn,
        //             MODULESNAME.memberinformation
        //         ).then(res => {
        //             this.$emit('getFramePath', res.url);
        //         });
        //         });
        //     }, 2000);
        // },

        //     /** 转化为Blob*/
        // dataURItoBlob(dataURI) {
        //     var byteString = atob(dataURI.split(',')[1]);
        //     var mimeString = dataURI
        //         .split(',')[0]
        //         .split(':')[1]
        //         .split(';')[0];
        //     var ab = new ArrayBuffer(byteString.length);
        //     var ia = new Uint8Array(ab);
        //     for (var i = 0; i < byteString.length; i++) {
        //         ia[i] = byteString.charCodeAt(i);
        //     }
        //     return new Blob([ab], { type: mimeString });
        // }
    },
    mounted() {
        if (sessionStorage.getItem('renzheng')) {
            setTimeout(() => {
                // this.dialogVisible = true
                this.showVideo = true
            }, 100)
        } else {
            setTimeout(() => {
                // this.dialogVisible = true
                this.showVideo = true
            }, 100)
            // setTimeout(() => {
            //     this.dialogVisible = true
            // }, 100)
        }
        // this.showVideo = true
    },
    computed: {
        //计算高度
        computeHeight() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '550px';
            } else {
                return '250px';
            }
        },
    },
}
</script>
<style>
.index_page .el-dialog__title {
    font-size: 30px;
}

.index_page .el-dialog__header {
    padding-top: 38px;
}

.index_page .el-dialog__body {
    font-size: 16px;
}

/* 封面 */
.vjs-poster {
    width: 100%;
    height: 100%;
    background-size: cover;
}

.video-player {
    box-shadow: none !important;
}

.video-js {
    background-color: #ffffff !important;
}

.logoWrap {
    display: block;
    position: fixed;
    transform: translate(-50%, 0);
    left: 50%;
    width: 100%;
    /* min-width: 12.5rem; */
    /* max-width: 14.4rem; */
    /* height: 9rem; */
    height: 600px;
    background-color: transparent;
    z-index: 1;
    background: url('../assets/beijing2.png') center center / 101% 108% no-repeat;
}

.imgBox {
    position: absolute;
    /* top: 3.28rem; */
    top: 230px;
    /* left: 2.79rem; */
    left: 460px;
    width: 1039px;
    height: 223px;
    opacity: 1;
}

.imgBox img {
    width: 100%;
    height: 100%
}
</style>
<style scoped>
.hege::-webkit-scrollbar {
    width: 4px;
    background: #f2f3f5;
}

::-webkit-scrollbar-thumb {

    border-radius: 3px;
    background: #d8d8d8;
}

.just_center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.border_parent {
    width: 90%;
    margin: auto;
}

.slider_img {
    height: 550px;
    width: 100%;
}

.solve {
    margin-top: 30px;
    margin-bottom: 10px
}

.border {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    height: auto;
    margin: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.border_one {
    margin-left: 0;
}

.border_img_parent {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.product_mobile_content {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.product_mobile_img {
    width: 50%;
}

.product_mobile_title {
    font-weight: bold;
    text-align: center;
}

.product_pc_one {
    text-align: center;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.font_size_30 {
    font-size: 1.875em;
}

.product_font_style {
    font-size: 1.125em;
}

.product_pc_img {
    width: 100%
}

.product_pc_img_div {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
}

.product_pc {
    display: flex;
    width: 90%;
    margin: 20px auto;
    background: #F2F6FC;
    align-items: center;
}

.product_spec_title {
    margin-top: 30px;
    margin-bottom: 10px
}

.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.cooperation_parent {
    display: flex;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.border_spec {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    float: left;
    width: 25%;
    height: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
    font-size: 1.25em;
    font-weight: normal;
    padding: 0 20px;
    margin: 10px;
}

.border_title {
    font-family: "PingFang SC";
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
}

.border_content_one {
    margin-top: 20px;
    font-size: 1.125em;
    text-align: center;
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
    text-align: center;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px
}

.border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
    height: 70px;
}

.border_spec_content_one {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    text-align: center;
}

.border_spec_inner_last {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 25px;
    text-align: center;
}

.cooperation {
    margin-top: 30px;
    width: 100%;
}

.about_me {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    background: #F2F6FC;
}

.product_mobile_img_div {
    width: 50%;
    height: auto;
}

.product_mobile_content_one {
    margin-top: 20px;
    text-align: center;
}

.product_mobile_content_two {
    margin-top: 10px;
    text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
    .slider_img {
        height: 250px;
        width: 100%;
    }


    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 100%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
    }

    .border_img_parent {
        margin-top: 0;

    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        height: auto;
        background: #F2F6FC;
    }

    .product_mobile_content {
        width: 100%;
        margin-top: 15px;
    }

    .product_mobile_content_one {
        margin-top: 5px;
    }

    .product_mobile_content_two {
        margin-top: 5px;
    }

    .product_mobile_img_div {
        display: flex;
        width: 100%;
        height: auto;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .product_mobile_img {
        float: left;
    }

    .product_mobile_title {
        font-weight: bold;
    }

    .product_pc_one {
        width: 100%;
        margin-top: 15px;
    }

    .font_size_30 {
        font-size: 1.25em;
    }

    .product_font_style {
        font-size: 1em;
    }

    .product_pc_img {
        height: 280px;
        width: 320px;
    }

    .product_pc_img_div {
        width: 100%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .product_pc {
        display: flex;
        width: 90%;
        height: auto;
        margin: 20px auto;
        background: #F2F6FC;
        flex-direction: column;
    }

    .head-label {
        display: flex;
        margin-top: 10px;
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        height: auto;
        flex-direction: column;
    }

    .border_spec {
        float: left;
        height: auto;
        margin: 8px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }


    .border_title {
        font-family: "PingFang SC";
        margin-top: 5px;
        font-size: 1.125em;
        font-weight: bold;
    }

    .border_content_one {
        margin-top: 5px;
        font-size: 1.125em;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
    }

    .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        /*background-color: aqua;*/
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
    }

    .border_spec_inner_last {
        /*background-color: bisque;*/
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 8px;
    }

    .about_me {
        display: flex;
        margin-top: 10px;
        width: 100%;
    }
}

.border_spec_img {
    width: 75px;
    height: 55px;
    align-self: center
}

.font_size_24 {
    font-size: 32px;
}
</style>
<style scoped>
.pd_wrap {
    width: 100%;
    height: 100%;
}

.pd_wrap .pd_box {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* padding: 40px 60px 30px 60px; */
}

.pd_wrap .pd_box .pd_seriesBox {
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;
    height: 100%;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem {
    display: flex;
    flex-direction: column;
    padding-right: 30px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesTitle {
    height: 55px;
    line-height: 55px;
    margin-bottom: 15px;
    text-align: center;
    font-size: 24px;
    color: #fff;
    font-weight: 550;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem {
    padding: 30px;
    height: 100%;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text1 {
    height: 40px;
    line-height: 40px;
    font-size: 22px;
    text-align: center;
    color: #000;
    font-weight: 550;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text2 {
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    text-align: center;
    color: #E98642;
    font-weight: 550;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text3 {
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    text-align: center;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text4 {
    line-height: 34px;
    font-size: 18px;
    text-align: left;
    padding: 0 15px;
    padding-left: 20px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text4 .pd_textItemLabel {
    font-weight: 550;
    padding-left: 25px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text4 .pd_textItemContent {
    font-weight: 550;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text4 .pd_textItemContent2 {
    font-weight: 550;
    color: #E98642;
}


.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_text5 {
    line-height: 34px;
    font-size: 18px;
    text-align: center;
    padding: 0 15px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem .pd_seriesContent .pd_seriesContentItem .pd_interval {
    width: 100%;
    height: 2;
    border-bottom: 2px dashed #ccc;
    margin-top: 20px;
    margin-bottom: 30px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem1 {
    width: 20%;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem1 .pd_seriesTitle {
    background: #3A79DF;
    box-shadow: rgb(222, 222, 224) 0px 6px 12px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem1 .pd_seriesContent {
    background: #DEEAF6;
    box-shadow: rgb(222, 222, 224) 0px 6px 12px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem1 .pd_seriesContent .pd_seriesContentItem {
    background: #DEEAF6;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem2 {
    width: 40%;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem2 .pd_seriesTitle {
    background: #F7AD44;
    box-shadow: rgb(222, 222, 224) 0px 6px 12px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem2 .pd_seriesContent {
    display: flex;
    flex-direction: row;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem2  .pd_seriesContent .pd_seriesContentInterval {
    width: 15px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem2  .pd_seriesContent .pd_seriesContentItem {
    height: 82%;
    display: flex;
    flex: 1;
    flex-direction: column;
    background: #FFF7E2;
    box-shadow: rgb(222, 222, 224) 0px 6px 12px;
}


.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 {
    width: 40%;
    padding-right: 0;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 .pd_seriesTitle {
    background: #F1543C;
    box-shadow: rgb(222, 222, 224) 0px 6px 12px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 .pd_horizontalSpacer {
    height: 15px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 .pd_seriesContent {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 .pd_seriesContent .pd_seriesContentItem {
    flex-grow: 1;
    background: #FDEFE6;
    height: auto;
    box-shadow: rgb(222, 222, 224) 0px 6px 12px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 .pd_seriesContent .pd_seriesContentItem .pd_text1 {
    height: 50px;
    line-height: 50px;
}

.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 .pd_seriesContent .pd_seriesContentItem .pd_text2 {
    height: 50px;
    line-height: 50px;
}


.pd_wrap .pd_box .pd_seriesBox .pd_seriesItem3 .pd_seriesContent .pd_verticalSpacer {
    width: 15px;
}

.pd_detailBox {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;

}

.pd_prc-card {
    width: 33.3%;
    padding-right: 30px;
    margin-bottom: 30px;
}

.pd_prc-card:nth-child(3n) {
    padding-right: 0;
}


.pd_prc-card-content {
    display: inline-block;
    width: 100%;
    height: 100%;
    min-width: 400px;
    background: #fff;
    border-radius: 20px;
}

.pd_title {
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    background-size: cover;
}

.pd_card-indicators {
    display: inline-block;
    width: 49%;
    line-height: 40px;
}
    .pd_name {
        display: inline-block;
        width: 100px;
        margin-right: 10px;
    }



.pd_min-chart {
    height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue